import { render, staticRenderFns } from "./ResultText.vue?vue&type=template&id=74ff38bb&scoped=true&"
import script from "./ResultText.vue?vue&type=script&lang=js&"
export * from "./ResultText.vue?vue&type=script&lang=js&"
import style0 from "./ResultText.vue?vue&type=style&index=0&id=74ff38bb&prod&lang=scss&"
import style1 from "./ResultText.vue?vue&type=style&index=1&id=74ff38bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ff38bb",
  null
  
)

export default component.exports